var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 101.2L94.4 157.5c-7.6 3.1-7.5 13.9.1 16.9l136.7 54.2c12 4.8 25.4 4.8 37.4 0l136.7-54.2c7.6-3 7.7-13.8.1-16.9l-136.1-56.3c-12.5-5.2-26.4-5.2-38.8 0",
    fill: "#ffbf00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262 258.2v135.4c0 6.4 6.5 10.8 12.5 8.5L426.8 343c3.5-1.4 5.8-4.7 5.8-8.5V199.1c0-6.4-6.5-10.8-12.5-8.5l-152.3 59.1c-3.5 1.4-5.8 4.7-5.8 8.5",
    fill: "#26b5f8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.4 265.2L181.2 287l-4.6 2.2-95.4 45.7c-6 2.9-13.8-1.5-13.8-8.2V199.6c0-2.4 1.2-4.5 2.9-6.1.7-.7 1.5-1.3 2.3-1.7 2.3-1.4 5.5-1.7 8.3-.6l144.7 57.3c7.4 2.9 8 13.2.8 16.7",
    fill: "#ed3049"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 190.5c-1.8 0-3.5.5-4.8 1.3-.8.5-1.6 1-2.3 1.7L181.2 287l45.2-21.8c3.4-1.7 5.1-4.9 5.1-8.1 0-3.5-2-7.1-5.8-8.6L81 191.2c-1.1-.5-2.3-.7-3.4-.7",
    fill: "#b22437"
  })));
}

export default SvgIcon;